<template>
    <v-card flat class="">
        <judul-praktik :data="data"></judul-praktik>

        <v-data-table :headers="table.headers" :items="table.items" :options.sync="tableOptions"
            :server-items-length="table.totalItems" :loading="table.loading" dense class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Laporan Jaga</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="800px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn small color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="add()">
                                Tambah Data
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h6">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="4">
                                        <v-select v-model="form.editedItem.pembimbing_id" outlined hide-details dense
                                            label="Pembimbing :" :items="form.pembimbings" item-value="user_id"
                                            item-text="nama"></v-select>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field v-if="form.editedIndex == -1" v-model="form.editedItem.tanggal"
                                            label="Tanggal: " type="date" dense outlined hide-details></v-text-field>
                                        <v-text-field v-else readonly v-model="form.editedItem.tanggal" label="Tanggal: "
                                            type="date" dense outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field v-if="form.editedIndex == -1" v-model="form.editedItem.jam"
                                            label="Jam: " type="time" dense outlined hide-details></v-text-field>
                                        <v-text-field v-else readonly v-model="form.editedItem.jam" label="Jam: "
                                            type="time" dense outlined hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field v-model="form.editedItem.tempat" label="Tempat: " dense outlined
                                            hide-details></v-text-field>
                                        <v-textarea v-model="form.editedItem.hasil_diskusi" label="Hasil Diskusi:" dense
                                            outlined hide-details></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn small color="primary" @click="save()">
                                    Simpan
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <!-- <v-dialog v-model="dialogDelete" max-width="500px">
						<v-card>
							<v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="blue darken-1" @click="closeDelete">Cancel</v-btn>
								<v-btn color="blue darken-1" @click="deleteItemConfirm">OK</v-btn>
								<v-spacer></v-spacer>
							</v-card-actions>
						</v-card>
					</v-dialog> -->
                </v-toolbar>
            </template>
            <template v-slot:item.tanggal="{ item }">
                {{ formatDateTime(item.tanggal) }} {{ (item.jam) }}
            </template>
            <template v-slot:item.nama="{ item }">
                {{ (item.nama) }}
            </template>
            <template v-slot:item.tempat="{ item }">
                {{ (item.tempat) }}
            </template>
            <template v-slot:item.hasil_diskusi="{ item }">
                <v-textarea :value="item.hasil_diskusi" readonly dense outlined hide-details></v-textarea>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small @click="editItem(item)">
                    {{ icons.mdiPencil }}
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn x-small color="primary" @click="getDataFromApi()">
                    Reload
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import JudulPraktik from '@/components/JudulPraktik.vue'
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiDelete, mdiPencil } from '@mdi/js'

export default {
    components: {
        JudulPraktik,
    },
    data() {
        return {
            praktik_id: this.$route.params.praktik_id,
            data: {
                nama_institusi: '',
				nama_prodi: '',
                profesi: '',
                stase: '',
                tanggal_awal: '',
                tanggal_akhir: '',
            },
            icons: {
                mdiDelete,
                mdiPencil,
            },
            tableOptions: {},
            table: {
                loading: true,
                headers: [
                    { text: 'No', align: 'start', sortable: false, value: 'no', },
                    { text: 'Waktu', value: 'tanggal', sortable: false },
                    { text: 'Pembimbing', value: 'nama', sortable: false },
                    { text: 'Tempat', value: 'tempat', sortable: false },
                    { text: 'Hasil Diskusi', value: 'hasil_diskusi', sortable: false },
                    { text: '', value: 'actions', sortable: false },
                ],
                items: [],
                totalItems: 0,
            },
            dialog: false,
            form: {
                editedIndex: -1,
                editedItem: {
                    pembimbing_id: '',
                    tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
                    jam: new Date().toJSON().slice(11, 16).replace(/-/g, '-'),
                    tempat: '',
                    hasil_diskusi: '',
                },
                defaultItem: {
                    pembimbing_id: '',
                    tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
                    jam: new Date().toJSON().slice(11, 16).replace(/-/g, '-'),
                    tempat: '',
                    hasil_diskusi: '',
                },
                pembimbings: [],
            },
        }
    },
    watch: {
        tableOptions: {
            handler() {
                this.getDataFromApi()
            },
            deep: true,
        },
    },
    computed: {
        formTitle() {
            return this.form.editedIndex === -1 ? 'Tambah Data' : 'Edit Data'
        },
    },
    created() {
        this.getDetail()
        this.getPembimbings()
    },
    methods: {
        save() {
            if (this.form.editedIndex > -1) {
                const fmData = new FormData()
                fmData.append('id', this.form.editedItem.id)
                fmData.append('pembimbing_id', this.form.editedItem.pembimbing_id)
                fmData.append('kompetensi', this.form.editedItem.kompetensi)
                axiosPostAuth('api/Praktik/updateLaporanJaga', fmData)
                    .then(response => {
                        if (response.code === 200) {
                            this.getDataFromApi()
                            this.dialog = false
                        }
                        else {
                            alert(response.message)
                        }
                    })
                    .catch(error => {
                        alert(error)
                    })
            } else {
                const fmData = new FormData()
                fmData.append('praktik_id', this.praktik_id)
                fmData.append('tanggal', this.form.editedItem.tanggal)
                fmData.append('jam', this.form.editedItem.jam)
                fmData.append('pembimbing_id', this.form.editedItem.pembimbing_id)
                fmData.append('tempat', this.form.editedItem.tempat)
                fmData.append('hasil_diskusi', this.form.editedItem.hasil_diskusi)
                axiosPostAuth('api/Praktik/addLaporanJaga', fmData)
                    .then(response => {
                        if (response.code === 200) {
                            this.getDataFromApi()
                            this.dialog = false
                        }
                        else {
                            alert(response.message)
                        }
                    })
                    .catch(error => {
                        alert(error)
                    })
            }
        },
        getDataFromApi() {
            const { page, itemsPerPage } = this.tableOptions
            const fmData = new FormData()
            fmData.append('praktik_id', this.praktik_id)
            fmData.append('page', page)
            fmData.append('itemsPerPage', itemsPerPage)
            fmData.append('search', '')
            axiosPostAuth('api/Praktik/getLaporanJaga_datatable', fmData)
                .then(response => {
                    this.table.items = response.data
                    this.table.totalItems = response.total
                    this.table.loading = false
                })
                .catch(error => {
                    alert(error)
                })
        },
        add() {
            this.form.editedItem = Object.assign({}, this.form.defaultItem)
            this.form.editedIndex = -1
        },
        editItem(item) {
            this.form.editedIndex = this.table.items.indexOf(item)
            this.form.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        getDetail() {
            const fmData = new FormData()
            fmData.append('id', this.praktik_id)
            axiosPostAuth('api/Praktik/getPraktik', fmData)
                .then(response => {
                    this.data = Object.assign({}, response.data)
                })
                .catch(error => {
                    alert(error)
                })
        },
        getPembimbings() {
            const fmData = new FormData()
            fmData.append('praktik_id', this.praktik_id)
            axiosPostAuth('api/Praktik/getPembimbingPraktik', fmData)
                .then(response => {
                    this.form.pembimbings = response.data
                })
                .catch(error => {
                    alert(error)
                })
        },
        deleteItem(item) {
            const conf = confirm("Apakah yakin akan dihapus?")
            if (conf) {
                const fmData = new FormData()
                fmData.append('id', item.id)
                axiosPostAuth('api/Praktik/deleteUserPraktik', fmData)
                    .then(response => {
                        if (response.code === 200) {
                            this.getDataFromApi()
                        }
                        else {
                            alert(response.message)
                        }
                    })
                    .catch(error => {
                        alert(error)
                    })
            }
        },
    },
}
</script>